<template>
  <div class="loader" :class="loaderSize"/>
</template>

<script>
export default {
  props: ["size"],  // s: small, m: medium, l: large, default: s
  computed: {
    loaderSize() {
      return {
        loaderMedium: this.size == "m",
        loaderLarge: this.size == "l"
      }
    }
  },
}
</script>

<style scoped>
.loader {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

.loaderMedium {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  width: 50px;
  height: 50px;
}

.loaderLarge {
  border: 9px solid #f3f3f3;
  border-top: 9px solid #3498db;
  width: 80px;
  height: 80px;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
